import { __assign } from "tslib";
import { EmissionFactorInclude } from './EmissionFactor';
var emissionFactorQuery = {
    where: {
        deleted: false,
        OR: [{ usageEndDate: { gte: new Date() } }, { usageEndDate: null }],
    },
    include: EmissionFactorInclude,
};
export var ActivityDataSourceInclude = {
    emissionFactors: emissionFactorQuery,
    activityDataSourceTypes: true,
    parent: {
        include: {
            emissionFactors: emissionFactorQuery,
            parent: {
                include: {
                    parent: true,
                    emissionFactors: emissionFactorQuery,
                },
            },
        },
    },
};
export var ActivityDataSourceWithFactorsInclude = {
    activityDataSourceTypes: true,
    parent: {
        include: {
            emissionFactors: emissionFactorQuery,
            parent: {
                include: {
                    parent: true,
                    emissionFactors: emissionFactorQuery,
                },
            },
        },
    },
    children: {
        include: {
            emissionFactors: emissionFactorQuery,
            children: {
                include: {
                    emissionFactors: emissionFactorQuery,
                    children: {
                        include: {
                            emissionFactors: emissionFactorQuery,
                        },
                    },
                },
            },
        },
    },
    emissionFactors: emissionFactorQuery,
};
export var ActivityDataSourceWithChildrenInclude = function (_a) {
    var organizationId = _a.organizationId, calculationMethodId = _a.calculationMethodId, subcategoryId = _a.subcategoryId;
    return ({
        activityDataSourceTypes: true,
        activityDataSourceMappings: {
            include: { scope: true },
        },
        parent: {
            include: {
                emissionFactors: emissionFactorQuery,
                parent: {
                    include: {
                        parent: true,
                        emissionFactors: emissionFactorQuery,
                    },
                },
            },
        },
        emissionFactors: emissionFactorQuery,
        children: {
            where: __assign(__assign(__assign({}, (calculationMethodId && subcategoryId
                ? {
                    activityDataSourceMappings: {
                        some: {
                            calculationMethodId: calculationMethodId,
                            subcategoryId: subcategoryId,
                        },
                    },
                }
                : {})), { disabled: false }), (organizationId
                ? {
                    OR: [
                        { organizations: { some: { id: organizationId } } },
                        { organizations: { none: { id: undefined } } },
                    ],
                }
                : {})),
            include: {
                activityDataSourceTypes: true,
                parent: true,
                emissionFactors: emissionFactorQuery,
                children: {
                    where: __assign(__assign(__assign({}, (calculationMethodId && subcategoryId
                        ? {
                            activityDataSourceMappings: {
                                some: {
                                    calculationMethodId: calculationMethodId,
                                    subcategoryId: subcategoryId,
                                },
                            },
                        }
                        : {})), { disabled: false }), (organizationId
                        ? {
                            OR: [
                                { organizations: { some: { id: organizationId } } },
                                { organizations: { none: { id: undefined } } },
                            ],
                        }
                        : {})),
                    include: {
                        activityDataSourceTypes: true,
                        parent: {
                            include: {
                                emissionFactors: emissionFactorQuery,
                                parent: true,
                            },
                        },
                        emissionFactors: emissionFactorQuery,
                        children: {
                            where: __assign(__assign(__assign({}, (calculationMethodId && subcategoryId
                                ? {
                                    activityDataSourceMappings: {
                                        some: {
                                            calculationMethodId: calculationMethodId,
                                            subcategoryId: subcategoryId,
                                        },
                                    },
                                }
                                : {})), { disabled: false }), (organizationId
                                ? {
                                    OR: [
                                        { organizations: { some: { id: organizationId } } },
                                        { organizations: { none: { id: undefined } } },
                                    ],
                                }
                                : {})),
                            include: {
                                activityDataSourceTypes: true,
                                emissionFactors: emissionFactorQuery,
                                parent: {
                                    include: {
                                        emissionFactors: emissionFactorQuery,
                                        parent: {
                                            include: {
                                                parent: true,
                                                emissionFactors: emissionFactorQuery,
                                            },
                                        },
                                    },
                                },
                                children: {
                                    where: __assign(__assign(__assign({}, (calculationMethodId && subcategoryId
                                        ? {
                                            activityDataSourceMappings: {
                                                some: {
                                                    calculationMethodId: calculationMethodId,
                                                    subcategoryId: subcategoryId,
                                                },
                                            },
                                        }
                                        : {})), { disabled: false }), (organizationId
                                        ? {
                                            OR: [
                                                { organizations: { some: { id: organizationId } } },
                                                { organizations: { none: { id: undefined } } },
                                            ],
                                        }
                                        : {})),
                                    include: {
                                        activityDataSourceTypes: true,
                                        parent: {
                                            include: {
                                                emissionFactors: emissionFactorQuery,
                                                parent: {
                                                    include: {
                                                        emissionFactors: emissionFactorQuery,
                                                        parent: {
                                                            include: {
                                                                emissionFactors: emissionFactorQuery,
                                                                parent: true,
                                                            },
                                                        },
                                                    },
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    });
};
//# sourceMappingURL=ActivityDataSource.js.map